<template>
  <v-popup @close="$emit('close')">
    <div class="popup-close" @click="$emit('close')">
      <img src="~@/assets/icons/icon-popup-close.svg" />
    </div>
    <div class="check-empty">
      <img src="~@/assets/check-data-popup.svg" />
      <h2 class="check-empty__title">
        {{ $t("import.data.incomplete.title") }}
      </h2>
      <p class="check-empty__desc">
        {{ $t("import.data.incomplete.description") }}
      </p>
      <div class="check-empty__btns">
        <v-button class="button--white-border" @click="goToOrderSummary">
          <img src="~@/assets/icons/icon-basket-blue.svg" class="icon-left" />
          {{ $t("common.proceed") }}
        </v-button>
        <v-button id="check-data-confirm-button" primary @click="goToCheckData">
          <img src="~@/assets/icons/icon-check-data.svg" class="icon-left" />
          {{ $t("common.checkdata") }} ({{ number }})
        </v-button>
      </div>
    </div>
  </v-popup>
</template>

<script>
import { mapGetters } from "vuex";
import { VButton, VPopup } from "shared";

export default {
  name: "VCheckDataPopup",
  components: {
    VPopup,
    VButton
  },
  props: ["number"],
  computed: {
    ...mapGetters({
      workListId: "workLists/currentWorkListId"
    })
  },
  methods: {
    goToOrderSummary() {
      this.$emit("navigation");
      this.$router.push({ name: "orderSubmit", params: { workListId: this.workListId } });
    },
    goToCheckData() {
      this.$emit("navigation");
      this.$router.push({ name: "checkData" });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .popup {
  &__container {
    max-width: 589px;
    min-width: 0;
    width: 100%;
    padding: 69px 0 50px 0;
  }
}
.popup-close {
  position: absolute;
  right: 24px;
  top: 24px;
  cursor: pointer;
}
.check-empty {
  text-align: center;
  &__title {
    margin: 35px 0 16px 0;
    font-size: 16px;
    line-height: 17px;
    text-align: center;
    color: #333333;
  }
  &__desc {
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.464286px;
    color: #333333;
    max-width: 290px;
    margin: 0 auto;
  }
  &__btns {
    padding: 48px 0 0 0;
    .button {
      margin: 0 4px;
      padding: 7px 17px;
      img.icon-left {
        margin: 0 8px 0 0;
      }
    }
  }
}
</style>
